// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__4gAHT","requiredAsterisk":"Info_requiredAsterisk__3-Z0v"};